(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('photo-gallery')) {
    class PhotoGallery extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('.photo-gallery__button')];
        this.dialog = this.querySelector('.photo-gallery__lightbox');
        this.fullImg = this.querySelector('.photo-gallery__full');
        this.caption = this.querySelector('.photo-gallery__caption');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.current = 0;

        if (!this.dialog || !this.buttons.length) return;

        const single = this.buttons.length < 2;
        this.prevBtn.hidden = single;
        this.nextBtn.hidden = single;

        this.buttons.forEach((btn, i) => btn.addEventListener('click', () => this.open(i)));
        this.prevBtn.addEventListener('click', () => this.step(-1));
        this.nextBtn.addEventListener('click', () => this.step(1));
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());

        // Click on the dark area (not the image or buttons) closes the lightbox
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog || e.target.hasAttribute('data-stage')) this.dialog.close();
        });

        this.dialog.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.step(-1);
          if (e.key === 'ArrowRight') this.step(1);
        });

        // Swipe support
        let startX = 0;
        this.dialog.addEventListener('touchstart', (e) => { startX = e.changedTouches[0].clientX; }, { passive: true });
        this.dialog.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 50) this.step(dx > 0 ? -1 : 1);
        });

        // Restore page scrolling however the dialog closes (button, Esc, backdrop)
        this.dialog.addEventListener('close', () => { document.body.style.overflow = ''; });
      }

      disconnectedCallback() {
        document.body.style.overflow = '';
      }

      open(index) {
        this.show(index);
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }

      step(direction) {
        this.show(this.current + direction);
      }

      show(index) {
        const total = this.buttons.length;
        this.current = (index + total) % total;
        const { full, alt } = this.buttons[this.current].dataset;
        this.fullImg.src = full;
        this.fullImg.alt = alt || '';
        this.caption.textContent = alt ? alt + '  (' + (this.current + 1) + '/' + total + ')' : (this.current + 1) + '/' + total;

        // Preload the neighbours so next/prev feels instant
        [this.current - 1, this.current + 1].forEach((i) => {
          const neighbour = this.buttons[(i + total) % total];
          if (neighbour) new Image().src = neighbour.dataset.full;
        });
      }
    }

    customElements.define('photo-gallery', PhotoGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
